var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("代采订单列表")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData(true)
                }
              }
            },
            [_vm._v("刷新")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.resData
        ? _c(
            "el-row",
            {
              staticClass: "row",
              attrs: {
                gutter: 20,
                type: "flex",
                align: "middle",
                justify: "space-around"
              }
            },
            _vm._l(_vm.resData.status, function(item) {
              return _c(
                "el-col",
                {
                  key: item.key,
                  staticClass: "column",
                  attrs: { span: 24 / _vm.resData.status.length }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "status",
                      class: { active: _vm.status === item.key },
                      on: {
                        click: function($event) {
                          return _vm.selectStatus(item.key)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(item.label) +
                          "(" +
                          _vm._s(item.count) +
                          ")\n      "
                      )
                    ]
                  )
                ]
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "输入搜索：" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "代采单号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.woid,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "woid", $$v)
                                    },
                                    expression: "form.woid"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "商家" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.supply_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "supply_name", $$v)
                                    },
                                    expression: "form.supply_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "市场" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.market_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "market_name", $$v)
                                    },
                                    expression: "form.market_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      multiple: "",
                                      placeholder: "城市"
                                    },
                                    model: {
                                      value: _vm.form.city,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "city", $$v)
                                      },
                                      expression: "form.city"
                                    }
                                  },
                                  _vm._l(_vm.citys, function(item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "选择代采组",
                                      multiple: "",
                                      filterable: ""
                                    },
                                    model: {
                                      value: _vm.form.pgid,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "pgid", $$v)
                                      },
                                      expression: "form.pgid"
                                    }
                                  },
                                  _vm._l(_vm.optionsMap.optionsPg, function(
                                    item
                                  ) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      multiple: "",
                                      placeholder: "订单负责人"
                                    },
                                    model: {
                                      value: _vm.form.order_owner,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "order_owner", $$v)
                                      },
                                      expression: "form.order_owner"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.optionsMap.owner_option,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value
                                          }
                                        })
                                      }
                                    )
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "选择代采单状态"
                                        },
                                        model: {
                                          value: _vm.form.status,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "status", $$v)
                                          },
                                          expression: "form.status"
                                        }
                                      },
                                      _vm._l(
                                        _vm.optionsMap.optionsStatus,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "代采单类型" },
                                        model: {
                                          value: _vm.form.cg_type,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "cg_type", $$v)
                                          },
                                          expression: "form.cg_type"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { value: "-1", label: "全部" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.optionsMap.optionsCgType,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "支付方式" },
                                        model: {
                                          value: _vm.form.pay_tool,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "pay_tool", $$v)
                                          },
                                          expression: "form.pay_tool"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { value: "", label: "全部" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.optionsMap.optionsPayTools,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.key,
                                              attrs: {
                                                label: item.label,
                                                value: item.key
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "代采开单方式" },
                                        model: {
                                          value: _vm.form.order_type,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "order_type",
                                              $$v
                                            )
                                          },
                                          expression: "form.order_type"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { value: "", label: "全部" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.optionsMap.optionsOrderType,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "小店分发" },
                                    model: {
                                      value: _vm.form.is_dispense,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "is_dispense", $$v)
                                      },
                                      expression: "form.is_dispense"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "0" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "是", value: "1" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "否", value: "2" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { padding: "0 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "提交时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.create_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "create_time", $$v)
                                    },
                                    expression: "form.create_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "支付时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.pay_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "pay_time", $$v)
                                    },
                                    expression: "form.pay_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "代采单来源",
                                          multiple: ""
                                        },
                                        model: {
                                          value: _vm.form.source,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "source", $$v)
                                          },
                                          expression: "form.source"
                                        }
                                      },
                                      _vm._l(
                                        _vm.optionsMap.optionsSource,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("查询")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _vm.resData
            ? _c(
                "el-col",
                { staticClass: "data-statics", attrs: { span: 24 } },
                [
                  _vm._v("\n      数据汇总    \n      "),
                  _vm.status === -1 ||
                  _vm.status === 3 ||
                  _vm.status === 4 ||
                  _vm.status === 5 ||
                  _vm.status === 10
                    ? _c("span", [
                        _vm._v(
                          "代采金额总计：¥" +
                            _vm._s(_vm.resData.dataStatis.planPrice) +
                            "        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.status === -1 || _vm.status === 0
                    ? _c("span", [
                        _vm._v(
                          "财务待审核金额总计：¥" +
                            _vm._s(_vm.resData.dataStatis.cWwaitCheckPrice) +
                            "        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.status === -1 || _vm.status === 1
                    ? _c("span", [
                        _vm._v(
                          "财务待付款金额总计：¥" +
                            _vm._s(_vm.resData.dataStatis.waitPayPrice) +
                            "        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.status === -1 || _vm.status === 2
                    ? _c("span", [
                        _vm._v(
                          "财务已付款金额总计：¥" +
                            _vm._s(_vm.resData.dataStatis.payPrice) +
                            "        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.status === -1 || _vm.status === 9
                    ? _c("span", [
                        _vm._v(
                          "代采待审核金额总计：¥" +
                            _vm._s(_vm.resData.dataStatis.cgWaitCheckPrice) +
                            "        "
                        )
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c("div", { staticClass: "header" }, [
              _c("div", [_vm._v("数据列表：")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn-wrap" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "button",
                      attrs: { type: "default", size: "mini" },
                      on: { click: _vm.handleCutPayMode }
                    },
                    [_vm._v("切换代采单支付方式")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "button",
                      staticStyle: {
                        "margin-left": "auto",
                        "background-color": "coral"
                      },
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function($event) {
                          _vm.payVisible = true
                        }
                      }
                    },
                    [_vm._v("订单付款")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "button",
                      attrs: { type: "success", size: "mini" },
                      on: { click: _vm.output }
                    },
                    [_vm._v("\n            导出")]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-bottom": "0" } },
              [
                _vm.resData
                  ? _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          height: "600",
                          data: _vm.resData.list,
                          "tooltip-effect": "dark"
                        },
                        on: { "selection-change": _vm.handleSelectionChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            type: "selection",
                            width: "55",
                            selectable: _vm.checkboxInit
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "woid",
                            label: "代采订单"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { align: "center", label: "代采类型" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("p", [
                                      _vm._v(_vm._s(scope.row.cg_type_label))
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          color: "#2d59ec",
                                          "font-size": "14px",
                                          "line-height": "0"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              scope.row.is_dispense_label
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3614154622
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "source_text",
                            label: "代采来源"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "wcg_order_pay_tool",
                            label: "支付方式"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "market_nikename",
                            label: "市场"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "supply_name",
                            label: "商家",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { prop: "supply_city", label: "城市" }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "create_price",
                            label: "代采金额",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "sum_num",
                            label: "代采数量",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "sir_num",
                            label: "大货入库件数",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "dk_amount",
                            label: "前置金额",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "activity_price",
                            label: "活动服务费",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "",
                            label: "佣金",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(scope.row.service_fee) +
                                        "(" +
                                        _vm._s(scope.row.service_fee_rate) +
                                        ")\n            "
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1921680396
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "dispense_commission_amount",
                            label: "小店佣金",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "",
                            label: "退货服务费",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(scope.row.refund_service_fee) +
                                        "(" +
                                        _vm._s(
                                          scope.row.refund_service_fee_rate
                                        ) +
                                        ")\n            "
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2833182668
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "true_price",
                            label: "实付金额",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "ded_activity_fee",
                            label: "活动费用抵扣金额",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "return_profit_fee",
                            label: "让利佣金抵扣金额",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "ded_price",
                            label: "商品抵扣金额",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "pay_price",
                            label: "实际结算金额",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "status_label",
                            label: "代采单状态",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "pgname",
                            label: "代采组",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "owner_admin_name",
                            label: "订单负责人",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "create_time",
                            label: "提交时间",
                            width: "100",
                            sortable: "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "pay_time",
                            label: "支付时间",
                            width: "100",
                            sortable: "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "order_type",
                            label: "代采开单方式",
                            width: "100",
                            sortable: "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "操作",
                            "show-overflow-tooltip": "",
                            align: "center",
                            fixed: "right"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "small" },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleClick(scope.row)
                                          }
                                        }
                                      },
                                      [_vm._v("查看详情")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3583021460
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.curPage,
                        background: "",
                        layout: "total, prev, pager, next, jumper,sizes ",
                        total: _vm.resData.count,
                        "page-size": _vm.form.pagesize,
                        "page-sizes": [50, 100]
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.curPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.curPage = $event
                        },
                        "current-change": _vm.handleCurrentChange,
                        "size-change": _vm.handleSizeChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.payVisible
        ? _c(
            "div",
            [
              _c("pay-tem", {
                attrs: {
                  ids: _vm.multipleSelection,
                  url: _vm.url2,
                  pay_num: _vm.pay_num,
                  pay_money: _vm.pay_money
                },
                on: { onCloseDialog: _vm.onCloseDialog }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("CutPayModeDialog", { ref: "CutPayModeRef" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-926a44d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-926a44d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PurchaseOrderList.vue
// module id = null
// module chunks = 